import { AccessTimeIcon, Box, Button, Tooltip, type ButtonProps } from '@shared/components';

export default function TimePostponementButton(props: Readonly<ButtonProps>) {
  const { hidden, disabled, onClick, ...restProps } = props;

  if (hidden) return null;

  return (
    <Tooltip title={disabled ? 'เลยกำหนดเวลาในการเลื่อน' : undefined}>
      <Box component='span' sx={{ maxWidth: 'fit-content' }}>
        <Button
          {...restProps}
          disabled={disabled}
          onClick={onClick}
          sx={{ height: 'fit-content', minWidth: 'fit-content' }}
          startIcon={<AccessTimeIcon />}
        >
          เลื่อนเวลาสอบ
        </Button>
      </Box>
    </Tooltip>
  );
}
